export const MODIFY_USERS = 1;
export const DELETE_USERS = 2;
export const MODIFY_GROUPS = 3;
export const DELETE_GROUPS = 4;
export const MANAGE_BILLING = 5;
export const ACCESS_REPORTS = 6;
export const DELETE_PHOTOS = 7;
export const MOVE_PHOTOS = 8;
export const SHARE_PHOTOS = 9;
export const VIEW_USERS_PHOTOS = 10;
export const VIEW_GROUPS_PHOTOS = 11;
export const ACCESS_MOBILE_APP = 12;
export const MODIFY_PROJECTS = 13;
export const DELETE_PROJECTS = 14;
export const MANAGE_ACCOUNT = 15;
export const ACCESS_DOCUMENTS = 16;
export const MANAGE_COLLABORATIONS = 17;
export const MANAGE_TASK_LISTS = 18;
export const MANAGE_TASK_LISTS_TEMPLATES = 20;
export const MANAGE_REPORT_TEMPLATES = 21;

/** @returns boolean */
export const userHasPermission = (user, permission) => {
  if (!user || !permission) {
    return false;
  }

  if (!user.permissions) {
    return false;
  }

  return user.permissions.includes(permission);
};

export const userHasAnyPermissions = (user, permissions) => {
  if (!user || !permissions) {
    return false;
  }

  const permissionList = Array.isArray(permissions)
    ? permissions
    : [permissions];

  return permissionList.some((permission) => {
    return userHasPermission(user, permission);
  });
};
